import { environment } from './environment';

type EnvironmentValues = Record<string, unknown>;

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export function loadRuntimeConfig(): Promise<void> {
  return fetch('config.json', { cache: 'no-store' })
    .then((response) => (response.ok ? response.json() : {}))
    .then((config: EnvironmentValues) => applyRuntimeConfig(config))
    .catch(() => undefined);
}

function applyRuntimeConfig(config: EnvironmentValues): void {
  const values = environment as EnvironmentValues;
  for (const [key, value] of Object.entries(config)) {
    if (key in values && typeof value === 'string' && value !== '') {
      values[key] = convert(value, values[key]);
    }
  }
}

function convert(value: string, current: unknown): unknown {
  if (typeof current === 'boolean') {
    return value === 'true';
  }
  if (typeof current === 'number') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : current;
  }
  if (typeof current === 'string' && ISO_DATE.test(current) && !ISO_DATE.test(value)) {
    return current;
  }
  return value;
}
